import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Alert,
  Box,
} from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { CustomButton, CustomTextField } from '../../../common';

const validationSchema = Yup.object().shape({
  email: Yup.string().email('Ingresá un correo válido').required('Este campo es requerido'),
});

const SpamReminder = () => (
  <Box
    sx={{
      mt: 2,
      mb: 1,
      p: 1,
      borderRadius: 1.5,
      border: '1px solid rgba(94, 137, 79, 0.25)',
    }}
  >
    <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.primary' }}>
      Recordá revisar tu carpeta de spam o correo no deseado y buscá un correo desde:{' '}
      <Box component="p" sx={{ fontWeight: 1000, textAlign: 'center', p: 1, borderRadius: 1.5, border: '2px solid' }}>
        noreply@software-colonial.firebaseapp.com
      </Box>
    </Typography>
  </Box>
);

export const PasswordRecoveryDialog = ({
  open,
  onClose,
  onSubmit,
  isLoading = false,
  successMessage = '',
  errorMessage = '',
  defaultEmail = '',
}) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
    <DialogTitle>Recuperar contraseña</DialogTitle>
    <Formik
      initialValues={{ email: defaultEmail || '' }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          await onSubmit?.(values.email);
        } finally {
          setSubmitting(false);
        }
      }}
    >
      {({ values, errors, touched, handleChange, isSubmitting }) => {
        const isBusy = isSubmitting || isLoading;

        return (
          <Form>
            <DialogContent sx={{ pt: 1, pb: 0 }}>
              <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                Ingresá el correo con el que accedés a la plataforma. Si coincide con una cuenta
                activa vamos a enviarte un enlace para restablecer la contraseña.
              </Typography>

              <SpamReminder />

              {successMessage && (
                <Alert severity="success" sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.primary' }}>
                    {successMessage}
                  </Typography>
                </Alert>
              )}

              {errorMessage && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {errorMessage}
                </Alert>
              )}

              <CustomTextField
                name="email"
                label="Correo electrónico"
                type="email"
                placeholder="tu-correo@ejemplo.com"
                value={values.email}
                onChange={handleChange}
                error={touched.email && Boolean(errors.email)}
                helperText={touched.email && errors.email}
              />
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 3, pt: 2, gap: 1.5 }}>
              <CustomButton type="button" variant="text" onClick={onClose} disabled={isBusy}>
                Volver al inicio
              </CustomButton>
              <CustomButton type="submit" variant="base" isLoading={isBusy} disabled={isBusy}>
                Enviar instrucciones
              </CustomButton>
            </DialogActions>
          </Form>
        );
      }}
    </Formik>
  </Dialog>
);
